import {store} from '@/store/store';
import axios from 'axios';
import { ElMessageBox} from 'element-plus';
const download=(idfile:string,cnamefile:string,bdownload:boolean,callback:any)=> {
  const params = {
    idfile: idfile,
    ionline: bdownload == true ? 0 : 1
  };
  axios({
    url: store.state.config.upfile + '/fileapi/download',
    method: 'post',
    headers: {
      Authorization: 'sdfasfsfwrfrwer',
      cip: store.state.app.ip,
      idtoken: store.state.user.idtoken,      
      id: store.state.user.id,
      idappset: store.state.config.idappset,
      device: store.state.app.device
    },
    data: params,
    responseType: 'blob'
  })
    .then((res) => {
      if (res.status != 200) {
        ElMessageBox((res as any).statusText);
        return ;
      }
      console.log('res1',res)
      if ((res as any).data.type==='application/json'){
        const fileReader = new FileReader()
        fileReader.onloadend = () => {
          console.log('fileReader.result',fileReader.result)
          const jsonData = JSON.parse(fileReader.result as any)
          // 后台信息
          console.log('jsonData',jsonData)
          ElMessageBox.alert(jsonData.cerror);
        }
        fileReader.readAsText((res as any).data)
      }
      else{
        if (bdownload){
          const url = window.URL.createObjectURL(new Blob([(res as any).data]));
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', cnamefile);
          document.body.appendChild(link);
          link.click()
          document.body.removeChild(link);
        }
        else{
          const dataInfo = res.data
          const reader = new window.FileReader()
          reader.onload =  (e)=> {
            const result = (e as any).target.result
            const contentType =dataInfo.type
            // 生成blob图片,需要参数(字节数组, 文件类型)
            console.log('contenttype',contentType)
            const blob = new Blob([result], { type: contentType })
            // 使用 Blob 创建一个指向类型化数组的URL, URL.createObjectURL是new Blob文件的方法,可以生成一个普通的url,可以直接使用,比如用在img.src上
            const url = window.URL.createObjectURL(blob)
            callback(url,contentType,cnamefile,blob);
          }
          // 使用readAsArrayBuffer读取文件, result属性中将包含一个 ArrayBuffer 对象以表示所读取文件的数据
          reader.readAsArrayBuffer(dataInfo)
        }
      }
    })
    .catch((error) => {
      console.log('error',error)
      ElMessageBox.alert(error.error+':'+error.errorMassage);
    });
  return
}
export default download
